import { useEffect } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

import { ReceivePacketCallback } from '../../../types';
import { useInitXpointNativeSDK } from './useInitXpointNativeSDK';
import { useXpointGeofencingHandler } from './useXpointGeofencingHandler';
import { useRequestXpointNativePacket } from './useRequestXpointNativePacket';

import * as Types from '../types';

export const useXpointNativeIntegration = ({
    sdk,
    enable,
    transactionID,
    onConnect,
    onError,
    receivePacket,
    triggerGeolocation,
    geolocationType
}: {
    sdk: Types.XPointSDKInstance | null;
    enable: boolean;
    transactionID: string | null;
    useTransparentPopup: boolean;
    onConnect: CallableFunction;
    onError: CallableFunction;
    receivePacket: ReceivePacketCallback;
    triggerGeolocation: Types.TriggerGeolocationCallback;
    geolocationType: string;
}) => {
    const initXpointNativeSDK = useInitXpointNativeSDK();
    const requestXpointNativePacket = useRequestXpointNativePacket({
        sdk,
        transactionID,
        geolocationType
    });

    useXpointGeofencingHandler({
        triggerGeolocation,
        onConnect,
        receivePacket,
        onError
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        htcmdService.sendMessage('geofencingsupported');
    }, [sdk, enable, onConnect]);

    return {
        requestXpointNativePacket,
        initXpointNativeSDK
    };
};
